import dayjs, { Dayjs } from 'dayjs';
import { action, computed, makeAutoObservable } from 'mobx';

export class SubstitutionStore {
  /** Die markierte Zeile des Vertretungsplans, über den Termin – nicht über die Position, die sich beim Filtern und Neuladen verschiebt. */
  public selectedEventUuid: string | null = null;
  public selectedDay: Dayjs = dayjs().startOf('day').startOf('hour');
  // Zeitraum für Veranstaltungen/Abwesenheiten, begrenzt aufs Schuljahr (siehe useSubstitutionDateRange).
  // rangeEnd: undefined = Schuljahresende, null = Ende wird im Picker gerade gewählt
  public rangeStart: Dayjs | null = dayjs().startOf('day');
  public rangeEnd: Dayjs | null | undefined = undefined;

  constructor() {
    makeAutoObservable(this, {
      setSelectedDay: action,
      setRange: action,
      dateString: computed,
    });
  }

  public get dateString(): string {
    return this.selectedDay.clone().format('YYYY-MM-DD');
  }

  public setSelectedEventUuid(uuid: string | null) {
    this.selectedEventUuid = uuid;
  }

  public setSelectedDay(date: Dayjs) {
    this.selectedEventUuid = null;
    this.selectedDay = date.startOf('day').startOf('hour');
  }

  public setRange(start: Dayjs | null, end: Dayjs | null) {
    this.rangeStart = start?.startOf('day') ?? null;
    this.rangeEnd = end?.startOf('day') ?? null;
  }
}
